import { trackingTopics } from '@/mocks/homepage';

export default function TrackingSection() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-accent-50/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2.5 h-2.5 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider whitespace-nowrap">
              实时追踪
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-3">
            全网正在 / 热议追踪
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            每分钟更新网友追踪讨论，热度不降不换榜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trackingTopics.map((topic, index) => (
            <a
              key={topic.id}
              href={`/article/${topic.id}`}
              className="block p-6 rounded-xl bg-background-50 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < topic.heat
                        ? 'ri-fire-fill text-accent-500'
                        : 'ri-fire-line text-secondary-300'
                    }`}
                  ></i>
                ))}
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                {topic.title}
              </h3>
              <p className={`text-sm leading-relaxed mb-5 line-clamp-3 ${
                index === 5 ? 'text-secondary-400' : 'text-foreground-600'
              }`}>
                {topic.summary}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full overflow-hidden border-2 border-background-50 flex-shrink-0">
                  <img
                    src={topic.avatar}
                    alt={topic.user}
                    title={`${topic.user} - 爆料追踪用户头像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{topic.user}</p>
                  <p className="text-xs text-foreground-500">{topic.time}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}